import { PRESENCE_OFFLINE, PRESENCE_ONLINE } from './contants';

export const validateSendPresenceActivityParams = (parameters) => {
  const presence = parameters?.presence;
  const presenceValues = [PRESENCE_OFFLINE, PRESENCE_ONLINE];

  if (!presence) {
    return new Error('A presence value must be provided.');
  }

  if (!presenceValues.includes(presence)) {
    return new Error(`presence must be one of: online, offline`);
  }

  return undefined;
};
